import { render, staticRenderFns } from "./ResearchSingleSearchCFDE.vue?vue&type=template&id=03b31452&scoped=true"
import script from "./ResearchSingleSearchCFDE.vue?vue&type=script&lang=js"
export * from "./ResearchSingleSearchCFDE.vue?vue&type=script&lang=js"
import style0 from "./ResearchSingleSearchCFDE.vue?vue&type=style&index=0&id=03b31452&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b31452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03b31452')) {
      api.createRecord('03b31452', component.options)
    } else {
      api.reload('03b31452', component.options)
    }
    module.hot.accept("./ResearchSingleSearchCFDE.vue?vue&type=template&id=03b31452&scoped=true", function () {
      api.rerender('03b31452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSingleSearchCFDE.vue"
export default component.exports